export default "__VITE_ASSET__1c5fd9e8__"